import React from "react";
import { Card, Column, Divider, Icon, Row, Text } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Inspection } from "src/data/types";
import { utcDateFormatTo12HrFormat } from "src/utils/dateUtil";
import { useNavigate } from "react-router-dom";
type CompletedInspectionCardProps = {
  inspection: Inspection;
};
const CompletedInspectionCard = ({
  inspection,
}: CompletedInspectionCardProps) => {
  const navigate = useNavigate();
  return (
    <Column>
      <Card
        onClick={() => {
          navigate(`/configurationDrivenInspections/${inspection.inspectionId}/review`);
        }}
        spacingInset={"300 400"}
      >
        <Row alignmentHorizontal="justify" alignmentVertical="center">
          <Column spacing={"200"}>
            <Row>
              <Text type="b300">{inspection.templateName}</Text>
            </Row>
            <Row>
              <Text type="b100" color="secondary">
                {inspection.siteCode}
              </Text>
              <Text type="b100">{`Compliance ${inspection.complianceStats.compliantCount}/${inspection.complianceStats.questionCount}`}</Text>
            </Row>
            <Row>
              <Divider />
            </Row>
            <Row>
              <Text type="b100" color="secondary">
                {utcDateFormatTo12HrFormat(inspection.createdAt)}
              </Text>
            </Row>
          </Column>
          <Column>
            <Icon tokens={chevronRightSmallTokens} color="primary" />
          </Column>
        </Row>
      </Card>
    </Column>
  );
};

export default CompletedInspectionCard;
